/**
 * ConditionNode - Modern diamond-shaped condition node
 * Shows visual indicators for connected/disconnected handles
 */

import { memo, useMemo } from 'react';
import { Handle, Position, useEdges } from '@xyflow/react';
import { ICON_MAP } from '../../constants/iconMap';

const ConditionNode = ({ id, data, selected }) => {
  const edges = useEdges();

  // Memoize connection status to avoid recalculating on every render
  const connectionStatus = useMemo(() => {
    const nodeEdges = edges.filter(e => e.source === id);
    return {
      hasTrue: nodeEdges.some(e => e.sourceHandle === 'true'),
      hasFalse: nodeEdges.some(e => e.sourceHandle === 'false'),
    };
  }, [edges, id]);

  // Resolve o ícone APENAS pelo ICON_MAP (não usar data.icon que não pode ser serializado)
  const Icon = ICON_MAP[data.iconKey] || ICON_MAP[data.key];

  // Build class names for handles
  const trueHandleClass = `afc-handle afc-handle-source condition-true ${connectionStatus.hasTrue ? 'connected' : 'disconnected'}`;
  const falseHandleClass = `afc-handle afc-handle-source condition-false ${connectionStatus.hasFalse ? 'connected' : 'disconnected'}`;

  return (
    <div className={`afc-node afc-node-condition ${selected ? 'selected' : ''}`}>
      {/* Handle de entrada (topo) */}
      <Handle
        type="target"
        position={Position.Top}
        className="afc-handle afc-handle-target"
      />

      {/* Handle Não (esquerda) */}
      <Handle
        type="source"
        position={Position.Left}
        id="false"
        className={falseHandleClass}
        title="Conecte aqui o próximo passo quando a condição for FALSA"
      />

      {/* Handle Sim (direita) */}
      <Handle
        type="source"
        position={Position.Right}
        id="true"
        className={trueHandleClass}
        title="Conecte aqui o próximo passo quando a condição for VERDADEIRA"
      />

      {/* Label Não */}
      <div className={`afc-condition-label-left ${connectionStatus.hasFalse ? 'connected' : ''}`}>
        Não
      </div>

      {/* Label Sim */}
      <div className={`afc-condition-label-right ${connectionStatus.hasTrue ? 'connected' : ''}`}>
        Sim
      </div>

      {/* Conteúdo do nó (diamante) */}
      <div className="afc-condition-diamond" style={{ '--gradient': data.gradient }}>
        <div className="afc-condition-content">
          <div className="afc-node-icon-wrapper small" style={{ background: data.gradient }}>
            {Icon && <Icon size={16} stroke={1.5} />}
          </div>
          <span className="afc-condition-label">{data.label}</span>
        </div>
      </div>
    </div>
  );
};

export default memo(ConditionNode);
